import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const RapidCity = () => {
  useEffect(() => {
    document.title = 'We Buy Valves Rapid City | Industrial Equipment Buyers Rapid City South Dakota';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Premier valve and instrumentation buyer serving Rapid City and Western South Dakota mining operations, cement production, and industrial manufacturing facilities. Fast response, competitive pricing.');
    }
    
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'we buy valves rapid city, rapid city valve buyers, south dakota industrial equipment buyers, mining valves rapid city, black hills equipment buyers');
    
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/cities/rapid-city');
    
    const ogTags = [
      { property: 'og:title', content: 'We Buy Valves Rapid City | Industrial Equipment Buyers Rapid City South Dakota' },
      { property: 'og:description', content: 'Premier valve and instrumentation buyer serving Rapid City and Western South Dakota mining operations, cement production, and industrial manufacturing facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/cities/rapid-city' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    let geoPosition = document.querySelector('meta[name="geo.position"]');
    if (!geoPosition) {
      geoPosition = document.createElement('meta');
      geoPosition.setAttribute('name', 'geo.position');
      document.head.appendChild(geoPosition);
    }
    geoPosition.setAttribute('content', '44.0805;-103.2310');
    
    let geoRegion = document.querySelector('meta[name="geo.region"]');
    if (!geoRegion) {
      geoRegion = document.createElement('meta');
      geoRegion.setAttribute('name', 'geo.region');
      document.head.appendChild(geoRegion);
    }
    geoRegion.setAttribute('content', 'US-SD');
    
    let geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (!geoPlacename) {
      geoPlacename = document.createElement('meta');
      geoPlacename.setAttribute('name', 'geo.placename');
      document.head.appendChild(geoPlacename);
    }
    geoPlacename.setAttribute('content', 'Rapid City, South Dakota');
    
    let lastModified = document.querySelector('meta[http-equiv="last-modified"]');
    if (!lastModified) {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('http-equiv', 'last-modified');
      document.head.appendChild(lastModified);
    }
    lastModified.setAttribute('content', new Date().toISOString());

    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply Rapid City",
          "image": "https://valvesalessupply.com/logo.png",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Rapid City",
            "addressRegion": "SD",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 44.0805,
            "longitude": -103.2310
          },
          "telephone": "+1-214-854-5638",
          "email": "valvesalessupply@gmail.com",
          "url": "https://valvesalessupply.com/cities/rapid-city",
          "priceRange": "$$",
          "areaServed": {
            "@type": "City",
            "name": "Rapid City",
            "addressRegion": "SD"
          },
          "description": "Premier valve and instrumentation buyer serving Rapid City and Western South Dakota mining operations, cement production, and industrial manufacturing facilities."
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of mining valves do you buy in Rapid City?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase all types of mining valves including slurry valves, gate valves, ball valves, knife gate valves, and heavy-duty process valves from Rapid City mining operations and Black Hills facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy equipment from Wharf Resources and other mining operations?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we regularly purchase surplus equipment from Wharf Resources gold mining operations, cement plants, and all industrial facilities throughout the Rapid City and Black Hills region."
              }
            },
            {
              "@type": "Question",
              "name": "How fast can you respond in Rapid City?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide 24-hour quotes for Rapid City facilities with fast response times throughout Western South Dakota and the Black Hills region."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "South Dakota",
              "item": "https://valvesalessupply.com/south-dakota"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Rapid City",
              "item": "https://valvesalessupply.com/cities/rapid-city"
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-b from-[#1B3A5F] to-[#2B4A6F]">
        <div className="max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-5xl font-bold mb-6">We Buy Valves Rapid City</h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Premier valve and instrumentation buyer serving Rapid City and Western South Dakota's 
            mining operations, cement production, and industrial manufacturing facilities.
          </p>
        </div>
      </section>

      {/* Quick Contact Bar */}
      <section className="bg-white py-6 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center">
              <i className="ri-map-pin-line text-[#1B3A5F] text-2xl mr-3"></i>
              <span className="text-gray-700 font-semibold">Serving Rapid City &amp; Western South Dakota</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-[#1B3A5F] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#2B4A6F] transition-all duration-300 flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                (214) 854-5638
              </a>
              <a
                href="mailto:rapidcity@valvesalessupply.com"
                className="border-2 border-[#1B3A5F] text-[#1B3A5F] px-6 py-3 rounded-full font-semibold hover:bg-[#1B3A5F] hover:text-white transition-all duration-300 flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                Email Rapid City Team
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">
                Rapid City Industrial Equipment Buyers
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Valve Sales Supply provides specialized equipment purchasing services to Rapid City's 
                diverse industrial sector, including gold mining operations, cement manufacturing plants, 
                and heavy industrial facilities throughout the Black Hills region.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Our team has extensive experience acquiring surplus valves, instrumentation, and process 
                control equipment from mining operations, facility upgrades, and plant modernization 
                projects across Western South Dakota and the surrounding region.
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                {[
                  'Mining Industry Expertise',
                  '24-Hour Quotes',
                  'Heavy Equipment Removal',
                  'Competitive Pricing',
                  'Complete Documentation',
                  'Licensed &amp; Insured'
                ].map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3 text-xl"></i>
                    <span className="text-gray-700 font-semibold">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="rounded-3xl overflow-hidden shadow-lg">
              <img 
                src="https://public.readdy.ai/ai/img_res/047877651d9929095e228cb0db0f137d.jpg"
                alt="Rapid City Industrial Area"
                className="w-full h-96 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Major Facilities Served */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Rapid City Facilities We Serve
            </h2>
            <p className="text-gray-600 text-xl">
              Supporting Western South Dakota's mining and industrial sectors
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                name: 'Wharf Resources',
                type: 'Gold Mining',
                icon: 'ri-copper-diamond-line',
                description: 'Major gold mining operation in Lead, SD'
              },
              {
                name: 'Rapid City Cement',
                type: 'Cement Production',
                icon: 'ri-building-line',
                description: 'Large-scale cement manufacturing facility'
              },
              {
                name: 'Black Hills Energy',
                type: 'Power Generation',
                icon: 'ri-flashlight-line',
                description: 'Regional power generation facilities'
              },
              {
                name: 'Regional Mining Operations',
                type: 'Mining &amp; Minerals',
                icon: 'ri-hammer-line',
                description: 'Multiple mining facilities in Black Hills'
              },
              {
                name: 'Industrial Manufacturing',
                type: 'Heavy Manufacturing',
                icon: 'ri-tools-line',
                description: 'Metal fabrication and manufacturing plants'
              },
              {
                name: 'Water Treatment Plants',
                type: 'Municipal Infrastructure',
                icon: 'ri-drop-line',
                description: 'Regional water and wastewater facilities'
              }
            ].map((facility, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-3xl p-6">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${facility.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-2">{facility.name}</h3>
                <p className="text-gray-600 font-semibold mb-2">{facility.type}</p>
                <p className="text-gray-600 text-sm">{facility.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Equipment We Purchase in Rapid City
            </h2>
            <p className="text-gray-600 text-xl">
              Specialized in mining and heavy industrial equipment
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: 'Mining Valves',
                icon: 'ri-settings-3-line',
                items: ['Slurry Valves', 'Gate Valves', 'Ball Valves', 'Knife Gate Valves']
              },
              {
                title: 'Process Control',
                icon: 'ri-cpu-line',
                items: ['PLCs', 'SCADA Systems', 'Controllers', 'HMIs']
              },
              {
                title: 'Instrumentation',
                icon: 'ri-dashboard-line',
                items: ['Pressure Gauges', 'Flow Meters', 'Level Sensors', 'Transmitters']
              },
              {
                title: 'Safety Systems',
                icon: 'ri-shield-check-line',
                items: ['Relief Valves', 'Safety Valves', 'Gas Detection', 'Emergency Systems']
              }
            ].map((category, index) => (
              <div key={index} className="bg-white rounded-3xl p-6">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${category.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{category.title}</h3>
                <ul className="space-y-2">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-[#1B3A5F] mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Advantages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Why Rapid City Facilities Choose Us
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: 'Mining Expertise',
                icon: 'ri-copper-diamond-line',
                description: 'Specialized knowledge of mining industry equipment and processes with experience handling heavy-duty valves and instrumentation from gold mining operations.'
              },
              {
                title: 'Regional Coverage',
                icon: 'ri-map-pin-line',
                description: 'Comprehensive service throughout Western South Dakota and the Black Hills region with fast response times for all facility types.'
              },
              {
                title: 'Professional Team',
                icon: 'ri-award-line',
                description: 'Experienced, licensed, and insured professionals handling everything from small instrument lots to complete plant decommissioning projects.'
              }
            ].map((advantage, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-3xl p-8 text-center">
                <div className="w-20 h-20 bg-[#1B3A5F] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${advantage.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{advantage.title}</h3>
                <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Related Markets */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Other South Dakota Markets We Serve
            </h2>
            <p className="text-gray-600 text-xl">
              Comprehensive coverage across South Dakota
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-8">
            <Link
              to="/sioux-falls"
              className="bg-white rounded-2xl p-6 hover:shadow-lg transition-all duration-300 flex items-center justify-between group"
            >
              <div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-1">Sioux Falls</h3>
                <p className="text-gray-600">Eastern South Dakota Hub</p>
              </div>
              <i className="ri-arrow-right-line text-[#1B3A5F] text-2xl group-hover:translate-x-2 transition-transform"></i>
            </Link>
          </div>

          <div className="text-center">
            <Link
              to="/south-dakota"
              className="inline-flex items-center text-[#1B3A5F] font-semibold text-lg hover:underline"
            >
              View All South Dakota Cities
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-white text-4xl font-bold mb-6">
            Get Your Rapid City Equipment Quote Today
          </h2>
          <p className="text-gray-200 text-xl mb-10">
            Fast, professional service for all your surplus equipment needs in Western South Dakota
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link
              to="/contact"
              className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap"
            >
              REQUEST A QUOTE
            </Link>
            <a
              href="tel:214-854-5638"
              className="border-2 border-white text-white px-10 py-4 rounded-full text-xl font-semibold hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 flex items-center justify-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              (214) 854-5638
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RapidCity;
